export default __webpack_public_path__ + "media/src/features/housing-affordability-voucher-badge/assets/fair_housing-7e8bb3525f424cf4be556ce38befc53e.svg";